import { SITE, DEFAULT_WA_MESSAGE, whatsappLink } from "@/constants/site";

export default function MobileContactBar() {
  const waLink = whatsappLink(DEFAULT_WA_MESSAGE);

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-background-50 border-t border-background-200 px-3 py-3">
      <div className="flex items-stretch gap-3">
        <a
          href={`tel:${SITE.phoneTel}`}
          className="flex-1 inline-flex items-center justify-center gap-2 border border-foreground-300 text-foreground-900 font-semibold py-3 rounded-md whitespace-nowrap cursor-pointer"
        >
          <i className="ri-phone-line text-lg" />
          ARA
        </a>
        <a
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-[1.6] inline-flex items-center justify-center gap-2 bg-primary-600 text-background-50 font-bold py-3 rounded-md whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-xl" />
          WHATSAPP REZERVASYON
        </a>
      </div>
    </div>
  );
}